__turbopack_context__.v({
  "container": "Container-module__JQCAHW__container",
});
